<div class="wrapper-login" [appBgCache]="'loginBG' | asapClient">
    <div [class.effect-overlay]="('effectOverlay' | asapClient)" style="width: 100%;">
        <div class="blur" [class.effect-blur]="('effectBlur' | asapClient)">
            <div class="w-100" [class.grid-card-rounded]="theme.theme?.config?.gridCard=='round'" [class.grid-card-shadow]="theme.theme?.config?.gridShadow=='shadow'" [class.app-is-blocked]="theme.isBlocked">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<!-- Modern Premium Block Modal -->
<div *ngIf="theme.isBlocked" class="block-modal-overlay" [appBgCache]="'loginBG' | asapClient">
    <div class="block-modal-backdrop"></div>
    <div class="block-modal-card">
        <div class="glowing-bg-circle warning-style"></div>
        <div class="block-modal-header">
            <div class="lock-icon-wrapper warning-style">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="lock-icon">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            </div>
        </div>
        <div class="block-modal-body">
            <h1 class="block-modal-title">Atenção</h1>
            <p class="block-modal-desc">{{ theme.blockedText || 'Este portal encontra-se temporariamente suspenso. Para restabelecer o acesso ou obter mais detalhes, por favor entre em contato com a equipe de suporte.' }}</p>
            <div class="block-modal-action" *ngIf="theme.blockedUrl">
                <a [href]="theme.blockedUrl" target="_self" class="block-modal-btn">
                    Clique aqui para acessar a nova URL
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Global LGPD / GDPR Cookie Consent Component -->
<app-cookie-consent></app-cookie-consent>